export default class RequestReplyDto {
  /**
   * @type {number}
   */
  requestId;

  /**
   * @type {number}
   */
  docutaxClientId;

  /**
   * @type {string}
   */
  message = '';

  /**
   * @type {object}
   */
  uploadUrl;

  /**
   * @type {boolean}
   */
  hasResponded = false;

  constructor(opts = null) {
    if (opts != null) {
      if (opts.requestId != null) {
        this.requestId = opts.requestId;
      }
      if (opts.docutaxClientId != null) {
        this.docutaxClientId = opts.docutaxClientId;
      }
      if (opts.message != null) {
        this.message = opts.message;
      }
      if (opts.uploadUrl != null) {
        this.uploadUrl = opts.uploadUrl;
      }
      if (opts.hasResponded != null) {
        this.hasResponded = opts.hasResponded;
      }
    }
  }
}
